import alertToken from "@ext/markdown/elements/alert/edit/model/alertToken";
import { questionAnswerToken } from "@ext/markdown/elements/answer/edit/models/answerToken";
import blockFieldToken from "@ext/markdown/elements/blockContentField/edit/models/blockFieldToken";
import blockPropertyToken from "@ext/markdown/elements/blockProperty/edit/models/blockPropertyToken";
import fenceToken from "@ext/markdown/elements/codeBlockLowlight/edit/logic/token";
import codeBlockToken from "@ext/markdown/elements/codeBlockLowlight/edit/model/token";
import colorToken from "@ext/markdown/elements/color/edit/model/colorToken";
import fragmentToken from "@ext/markdown/elements/fragment/edit/model/fragmentToken";
import fragmentLinkToken from "@ext/markdown/elements/fragment-link/edit/model/fragmentLinkToken";
import galleryToken from "@ext/markdown/elements/gallery/edit/model/galleryToken";
import headingToken from "@ext/markdown/elements/heading/edit/model/headingToken";
import highlightToken from "@ext/markdown/elements/highlight/edit/model/token";
import htmlToken from "@ext/markdown/elements/html/edit/models/htmlToken";
import htmlTagTokens from "@ext/markdown/elements/htmlTag/edit/model/htmlTagTokens";
import iconToken from "@ext/markdown/elements/icon/edit/model/iconToken";
import inlineImageToken from "@ext/markdown/elements/inlineImage/edit/models/token";
import inlinePropertyToken from "@ext/markdown/elements/inlineProperty/edit/models/inlinePropertyToken";
import { bulletList } from "@ext/markdown/elements/list/edit/models/bulletList/bulletListToken";
import { listItem } from "@ext/markdown/elements/list/edit/models/listItem/model/listItemToken";
import { orderedList } from "@ext/markdown/elements/list/edit/models/orderList/orderListToken";
import { taskList } from "@ext/markdown/elements/list/edit/models/taskList/model/taskListToken";
import noteToken from "@ext/markdown/elements/note/edit/model/noteToken";
import openApiToken from "@ext/markdown/elements/openApi/edit/models/openApiToken";
import { questionToken } from "@ext/markdown/elements/question/edit/models/questionToken";
import sourceCommentToken from "@ext/markdown/elements/sourceComment/edit/models/sourceCommentToken";
import tableTokens from "@ext/markdown/elements/table/edit/model/tableTokens";
import tabToken from "@ext/markdown/elements/tabs/edit/model/tab/tabToken";
import tabsToken from "@ext/markdown/elements/tabs/edit/model/tabs/tabsToken";
import unsupportedToken from "@ext/markdown/elements/unsupported/edit/model/unsupportedToken";
import viewToken from "@ext/markdown/elements/view/edit/models/viewToken";
import commentToken from "../../../../elements/comment/edit/model/commentToken";
import answer from "../../../../elements/comment/legacy/answer/edit/answerToken";
import comment_old from "../../../../elements/comment/legacy/comment/commentToken";
import bpmnToken from "../../../../elements/diagrams/diagrams/bpmn/bpmnToken";
import mermaidToken from "../../../../elements/diagrams/diagrams/mermaid/mermaidToken";
import plantUmlToken from "../../../../elements/diagrams/diagrams/plantUml/plantUmlToken";
import diagramsToken from "../../../../elements/diagrams/edit/models/diagramsToken";
import drawioToken from "../../../../elements/drawio/edit/model/drawioToken";
import imageToken from "../../../../elements/image/edit/model/imageToken";
import linkToken from "../../../../elements/link/edit/model/linkToken";
import video from "../../../../elements/video/edit/model/videoToken";
import type PrivateParserContext from "../../../Parser/ParserContext/PrivateParserContext";
import type { ParseSpec } from "./from_markdown";
import tokensModifier from "./tokensModifier";

const getTokensByContext = (context?: PrivateParserContext): { [name: string]: ParseSpec } => {
	return {
		comment: commentToken(context),
		fragment: fragmentToken(context),
		snippet: fragmentToken(context),
		icon: iconToken(context),
	};
};

export const getTokens = (context?: PrivateParserContext): { [name: string]: ParseSpec } => {
	const contextTokens = context ? getTokensByContext(context) : {};
	const tokens = {
		link: linkToken(context),
		image: imageToken(context),
		inlineImage: inlineImageToken(context),
		drawio: drawioToken(context),
		openapi: openApiToken(context),
		mermaid: mermaidToken(context),
		diagrams: diagramsToken(context),
		"plant-uml": plantUmlToken(context),
		bpmn: bpmnToken(context),
		tab: tabToken,
		note: noteToken,
		unsupported: unsupportedToken,
		tabs: tabsToken,
		gallery: galleryToken,
		fence: fenceToken(),
		code_block: codeBlockToken,
		html: htmlToken,
		view: viewToken,
		question: questionToken(context),
		questionAnswer: questionAnswerToken(context),
		"inline-property": inlinePropertyToken(),
		"source-comment": sourceCommentToken("source-comment"),
		"inline-source-comment": sourceCommentToken("inline-source-comment"),
		"block-field": blockFieldToken(),
		"block-property": blockPropertyToken(),
		alert: alertToken(),
		highlight: highlightToken,

		br: { node: "br" },

		cut: {
			block: "cut",
			getAttrs: (tok) => {
				return { ...tok.attrs, isInline: false };
			},
		},
		...htmlTagTokens(context),
		blockMd: { node: "blockMd", getAttrs: (tok) => tok.attrs },
		...tableTokens,
		blockquote: { block: "blockquote" },
		paragraph: { block: "paragraph" },
		error: { block: "error" },
		list_item: listItem,
		task_list: taskList,
		bullet_list: bulletList,
		ordered_list: orderedList,
		heading: headingToken,

		hr: { node: "horizontal_rule" },

		hardbreak: { node: "hard_break" },
		softbreak: { node: "soft_break" },
		s: { mark: "s" },
		em: { mark: "em" },
		inlineMd: { mark: "inlineMd" },
		inlineCut: {
			mark: "inlineCut",
			getAttrs: (tok) => {
				return { ...tok.attrs, isInline: true };
			},
		},

		color: colorToken,
		"fragment-link": fragmentLinkToken(context),
		"snippet-link": fragmentLinkToken(context),
		strong: { mark: "strong" },
		code_inline: { mark: "code", noCloseToken: true },

		video,
		...contextTokens,

		answer,
		comment_old,
	};

	return tokensModifier(tokens, context);
};
